import { Component, OnInit, OnChanges, SimpleChanges, Input, ViewChild } from '@angular/core';
import { IonicPage, NavController, LoadingController, Nav, Slides, Platform } from 'ionic-angular';
import { HttpService } from '../../providers/HttpService';
import { SearchModel } from '../../models/SearchModel';
import { City, CarryStation } from '../../models/City';
import { Utils } from '../../providers/Utils';
import { IS_APP, LoadingImage } from '../../providers/Constants';
import { NativeService } from '../../providers/NativeService';
import { Storage } from '@ionic/storage';
import moment from 'moment';
import { BaseAuthorizePage } from '../../providers/BaseAuthorizePage'
import { ThemeableBrowser } from '@ionic-native/themeable-browser';


@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  @ViewChild(Nav) nav: Nav;
  @ViewChild('homeSlide') homeSlide: Slides;
  public defaultImage: string = LoadingImage;
  public result: any;
  public city: City[];
  public myslides: any[] = [{
    imageSrc: ''
  }];
  public tourismTelPhone: any = Array<any>();
  public charteredTelPhone: string;
  public selectCity: City;
  public selectCarryStation: CarryStation;
  drvDate: string;
  canRefresh: boolean = false;
  isApp: boolean;
  isShowMore: boolean;
  constructor(public navCtrl: NavController,
    loadingController: LoadingController,
    public httpService: HttpService,
    public nativeService: NativeService,
    public platform: Platform,
    public storage: Storage,
    public themeableBrowser: ThemeableBrowser,
    public searchModel: SearchModel) {
    this.selectCity = new City();
    this.searchModel.drvDate = moment().format('YYYY-MM-DD');// Utils.dateFormat(new Date(),'yyyy-MM-dd');
    this.searchModel.minDate = this.searchModel.drvDate;
    this.isApp = IS_APP;
    this.isShowMore = false;
  }

  carryStationChanged(carry) {
    this.searchModel.drvDate = this.searchModel.minDate;
    this.searchModel.startStation = this.selectCarryStation.carryStationId;
    this.searchModel.stopName = "";
    this.searchModel.stopId = "";
    this.searchModel.maxDate = moment(this.searchModel.minDate).add(this.selectCarryStation.preSaleDay, 'd').format('YYYY-MM-DD');
  }

  slideClick(item) {
    this.nativeService.slideClick(item);
  }

  cityChange(event) {
    this.searchModel.cityId = event.cityId;
    //this.selectCarryStation=event.carryStations[0];
    // this.searchModel.startStation=this.selectCarryStation.carryStationId;
    this.searchModel.maxDate = moment(this.searchModel.minDate).add(event.preSaleDay, 'd').format('YYYY-MM-DD');
  }


  searchSch() {
    if (this.searchModel.stopName == null || this.searchModel.stopName.length == 0) {
      this.nativeService.alert('请先选择目的站点');
      return;
    }
    this.addClick("售票");
    //记录历史
    this.storage.get('busstophistory').then(x => {
      if (x) {
        let zindex: number = x.findIndex(w => w == this.searchModel.stopName);
        if (zindex < 0) {
          //添加 并且删除多余的
          x.unshift(this.searchModel.stopName);
          if (x.length > 6) {
            x.splice(6);
          }
          this.storage.set('busstophistory', x);
        } else {
          //移动到第一位
          x.splice(zindex, 1);
          x.unshift(this.searchModel.stopName);
          this.storage.set('busstophistory', x);
        }
      } else {
        this.storage.set('busstophistory', [this.searchModel.stopName]);
      }
    });
    this.navCtrl.push('SchPage');
  }

  getDayName() {
    if (moment(this.searchModel.drvDate).diff(moment(this.searchModel.minDate), 'd') > 1) {
      return moment(this.searchModel.drvDate).format('ddd');
    }
    return moment(this.searchModel.drvDate).calendar().replace('00:00', '');
  }


  selectDate() {
    this.nativeService.selectDrvDate().subscribe(src => {

    })
  }
  public left: any = {};
  public right_top: any = {};
  public right_left: any = {};
  public right_right: any = {};
  public bottom: any = {};

  getCity() {
    this.httpService.post('GetCityStationV2')
      .subscribe(res => {
        var result = res.json().result;
        this.result = result;
        this.city = result.city;
        this.selectCity = this.city[0];
        this.cityChange(this.selectCity);
        this.canRefresh = false;
        this.searchModel.drvDate = result.sysDate;
        this.searchModel.minDate = result.sysDate;
        this.tourismTelPhone = result.phone.tourismTelPhone;
        this.charteredTelPhone = result.phone.charteredTelPhone;

        if (result.slideshows && result.slideshows.length > 0) {
          this.myslides = result.slideshows;

          this.homeSlide.loop = true;
          this.homeSlide.update();
        }

        if (result.homeImages) {

          result.homeImages.forEach(item => {
            switch (item.homeImageLocation) {
              case '正左侧':
                this.left = item;
                break;
              case '右上侧':
                this.right_top = item;
                break;
              case '右左侧':
                this.right_left = item;
                break;
              case '右右侧':
                this.right_right = item;
                break;
              case '正下侧':
                this.bottom = item;
                break;
              default:
            }
          });
        }
      }, err => {
        this.canRefresh = true;
      });
  }

  compareFn(e1: City, e2: City): boolean {
    return e1 && e2 ? e1.cityId === e2.cityId : e1 === e2;
  }

  doRefresh(refresher) {
    this.getCity();
    refresher.complete();
  }

  ionViewDidEnter() {
    //this.navCtrl.parent.select(0);
  }

  qichezulin() {
    // this.addClick("租赁");
    var url = "https://mp.weixin.qq.com/s?__biz=MzU2NzI3OTQ1NA==&mid=2247483723&idx=1&sn=74aaf710f21109ab813dd5b98a981483&chksm=fc9eeb7acbe9626c61635d5f2f9273cdc4cd1217e793705f9f5f42c974d67113f9bdf390df17&mpshare=1&scene=1&srcid=0930nnPtl43WxW3YxGCxDeWH&sharer_sharetime=1604974007691&sharer_shareid=5a3e4de71fe55be25ef027144be7e1f8&key=058f23f5cf0ad408494cc2aecc5aa779cbec0779e3bcc2c4fa5e605eb2fd7e456742afc93791113bbf2469bd23d3d7a775bb0fdee72b21d7a4c553477862a1788e40cb48551ce1a39dd0023db26eb82f01544a9bb5cc12cd760526941720b0ed484168e2e697c1e9af4d00b0af2bdfc51c1563f1cd6c295b0e118587696fe806&ascene=1&uin=NDkzNzM0NDU1&devicetype=Windows+10+x64&version=6300002f&lang=zh_CN&exportkey=ARm%2FgGyfXM7fY%2BOQi%2FzgZmc%3D&pass_ticket=p2mztzTEW1Uk8W%2BGkKu2%2F4ye1BBCW%2BsUz4ANMDXBfG1jyxMkT2Rx54gaCw7L8%2BvR&wx_header=0http://www.hyszlgs.com/";
    this.themeableBrowser.create(url, '_system', NativeService.options);
  }

  Chartered() {
    this.addClick("包车");
    this.navCtrl.push("CharteredHomePage");
  }

  HomeTourism() {
    this.addClick("旅游");
	var url = "https://m.hxtrip.com/www/";
    this.themeableBrowser.create(url, '_system', NativeService.options);
   // this.navCtrl.push("HomeTourismPage");
  }

  addClick(name: string) {
    this.httpService.post('AddClicks', { "ClickSourceId": this.nativeService.getOrderResource(), "name": name })
      .subscribe();
  }

  gongjiaosaoma() {
    this.addClick("扫码");
	// this.navCtrl.push("BusscanHomePage");
    if (this.isApp) {
      if (this.nativeService.getOrderResource() == 'Android') {
        this.navCtrl.push("BusscanHomePage");
      }
      else if (this.nativeService.getOrderResource() == 'Ios') {
        this.nativeService.showToast("暂未开通此服务！敬请期待。");
        //var url ="http://hzx.sxhys.com/Down/App";   
        //this.themeableBrowser.create(url, '_system', NativeService.options); 
      }
    }
    else {
      window.location.href = "https://hanzhongxing.cn/Down/App";
    }
  }

  zinenggongjiao() {
    this.addClick("智能公交");
    var url = "http://ad.16bus.net:83/bushanzhongthird/index.html";
    this.themeableBrowser.create(url, '_system', NativeService.options);
  }

  wuliuchadan() {
    this.addClick("物流查单");
    var url = "http://weixin.915566.com/hanyunsi.asp";
    this.themeableBrowser.create(url, '_system', NativeService.options);
  }

  chengjikuaiche() {
    this.addClick("城际快车");
    var url = "https://zhuanti.chebada.com/zhuanti/release/app/2019/03/hanzhonggoout/index.html?v=0313";
    this.themeableBrowser.create(url, '_system', NativeService.options);
  }

  dingzhikeyun() {
    this.addClick("定制客运");
    var url = "https://weixin.bbxpc.com/wechath5/order";
    this.themeableBrowser.create(url, '_system', NativeService.options);
  }

  xiaojianxiadan() {
    this.addClick("小件下单");
    this.navCtrl.push("SendgoodsFillinPage");
  }


  notService() {
    this.nativeService.showToast("暂未开通此服务！敬请期待。");
  }

  fenxiao() {
    this.addClick("旅游分销");
    this.navCtrl.push("TourismPyramidsellPage", { phone: this.tourismTelPhone });
  }

  couponCenter() {
    this.addClick("领券中心");
    this.navCtrl.push("CouponCenterPage");
  }

  applicationInvoice() {
    this.addClick("发票申请");
    this.navCtrl.push("InvoiceHomePage");
  }


  ionViewDidLoad() {
    if (!this.navCtrl.parent) {
      this.navCtrl.setRoot("TabsPage");
    }
    this.getCity();
  }

  showMore() {
    if (this.isShowMore) {
      this.isShowMore = false;
    }
    else {
      this.isShowMore = true;
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts